export let recoverableItemsFolderDescription = "acPEmc";
export default {recoverableItemsFolderDescription};